var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-1/2 mt-10 mb-16 print:hidden"},[_c('hr',{staticClass:"mt-4 mb-4 border-t border-gray-400 w-full"}),_c('div',[_c('MainButton',{attrs:{"title":_vm.nextpagetext,"purple":"","medium":"","shadow":""},on:{"click":function($event){return _vm.nextPage()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }